<script setup lang="ts">
import type {NuxtError} from "#app";

const props = defineProps({
  error: Object as () => NuxtError,
});

const handleError = () => clearError({redirect: "/"});
</script>

<template>
  <NuxtLayout>
    <UPage id="pagePage" class="lg:flex lg:flex-col h-full min-h-[calc(100vh-var(--ui-header-height)-var(--ui-footer-height))] justify-center">
      <div id="pageBody">
        <UContainer>
          <div class="text-center" v-if="error">
            <template v-if="error.status === 404">
              <h2 class="text-h1">{{ error.status }}</h2>
              <h3 class="text-h2 mb-4">{{ error.message }}</h3>
              <p class="text-xl font-semibold mb-8">La page demandée n'existe pas.</p>
              <UButton color="secondary" variant="solid" href="/decouvrir">Découvrez toutes nos histoires</UButton>
            </template>
            <template v-else>
              <h2 class="text-h1">{{ error.status }}</h2>
              <h3 class="text-h2">{{ error.message }}</h3>
              <p>Une erreur est survenue.</p>
            </template>
          </div>
        </UContainer>
      </div>
    </UPage>
  </NuxtLayout>
</template>
